import { isArray, isPlainObject } from 'lodash';
import { rejectFalsyItems, rejectFalsyProperties } from '../apiTransformers/transformers';
import { LOG_TYPE } from '../const';
import { logger } from '../logger/logger.class';
/**
 * RejectFalsy - filter resulting object or array to exclude falsy values
 *
 * @param function
 * @returns function
  ```
  import { isArray, isPlainObject } from 'lodash';
  import { rejectFalsyItems, rejectFalsyProperties } from '../apiTransformers/transformers';
  import { LOG_TYPE } from '../const';
  import { logger } from '../logger/logger.class';
  import { Dictionary } from '../model/globals.model';

  @RejectFalsy
  getQuery(route: Dictionary<unknown>): Dictionary<string | (string | null)[]> {

  ```
 */
export function RejectFalsy(options = { whitelist: [] }) {
    return function (_target, _propertyKey, descriptor) {
        const original = descriptor.value;
        descriptor.value = function (...args) {
            const originalResult = original.apply(this, args);
            if (isArray(originalResult)) {
                return rejectFalsyItems(originalResult, options);
            }
            else if (isPlainObject(originalResult)) {
                return rejectFalsyProperties(originalResult, options);
            }
            logger.message('Result incompatible with decorator, skipping decorator', LOG_TYPE.warning);
            return originalResult;
        };
    };
}
